var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamaskIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.486 2.006L9.864 6.18l1.04-2.463 4.582-1.712z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.508 2.006L8.085 6.22l-.989-2.502-4.588-1.712zM13.463 11.684l-1.497 2.293 3.203.882.921-3.124-2.627-.051zM1.915 11.735l.915 3.124 3.204-.882-1.497-2.293-2.622.05z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.853 7.808l-.893 1.35 3.181.141-.113-3.418-2.175 1.927zM12.141 7.808L9.938 5.842l-.074 3.457 3.175-.14-.898-1.351zM6.034 13.977l1.91-.932-1.65-1.288-.26 2.22zM10.05 13.045l1.916.932-.265-2.22-1.65 1.288z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.966 13.977l-1.915-.932.152 1.249-.016.525 1.78-.842zM6.034 13.977l1.78.842-.012-.525.142-1.249-1.91.932z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.842 10.932l-1.593-.469 1.124-.514.469.983zM10.152 10.932l.47-.983 1.13.514-1.6.47z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.034 13.977l.271-2.293-1.768.05 1.497 2.243zM11.695 11.684l.271 2.293 1.497-2.242-1.768-.051zM13.04 9.158L9.864 9.3l.294 1.633.47-.983 1.13.514 1.282-1.305zM6.249 10.463l1.13-.514.463.983.3-1.633-3.182-.14 1.289 1.304z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.96 9.158l1.334 2.6-.045-1.295L4.96 9.158zM11.757 10.463l-.056 1.294 1.338-2.599-1.282 1.305zM8.141 9.3l-.3 1.632.374 1.927.084-2.537-.158-1.023zM9.864 9.3l-.152 1.016.068 2.543.378-1.927L9.864 9.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.158 10.932L9.78 12.86l.27.186 1.65-1.288.057-1.294-1.599.47zM6.249 10.463l.045 1.294 1.65 1.288.27-.186-.372-1.927-1.593-.469z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.187 14.82l.016-.526-.14-.125h-2.13l-.13.125.01.525-1.78-.842.622.509 1.26.876h2.164l1.266-.876.621-.509-1.78.842z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.05 13.045l-.27-.186H8.215l-.271.186-.142 1.249.13-.125h2.13l.141.125-.152-1.249z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.723 6.452l.48-2.305-.717-2.141L10.05 6.04l2.09 1.768 2.955.864.655-.762-.282-.204.452-.412-.35-.271.452-.345-.3-.226zM1.797 4.147l.48 2.305-.305.226.452.345-.345.27.452.413-.282.204.65.762 2.954-.864 2.09-1.768L2.51 2.006l-.712 2.14z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.096 8.672l-2.955-.864.899 1.35-1.34 2.599 1.763-.023h2.627l-.994-3.062zM5.853 7.808l-2.955.864-.983 3.062h2.622l1.757.023L4.96 9.158l.893-1.35zM9.864 9.3l.187-3.26.859-2.322H7.096l.848 2.322.197 3.26.068 1.028.006 2.53H9.78l.011-2.53.073-1.029z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskIcon);
export default __webpack_public_path__ + "static/media/metamask-icon.052ac19c.svg";
export { ForwardRef as ReactComponent };